var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGla(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 32,
    viewBox: "0 0 25 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1",
    clipPath: "url(#clip0_80_4441)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.4786 31.25H16.1206L6.55528 16.908L11.338 9.42065H5.71128C4.86728 9.42065 4.09361 9.77217 3.74195 10.3698L0.365945 15.6425C-0.126389 16.451 -0.126389 17.365 0.401111 18.1735L8.03228 29.633C8.70045 30.6172 10.0016 31.25 11.4786 31.25Z",
    fill: "url(#paint0_linear_80_4441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.03228 29.633C4.23428 23.9384 3.95295 21.0208 6.55528 16.908L11.338 9.42065H5.71128C4.86728 9.42065 4.09361 9.77217 3.74195 10.3698L0.365945 15.6425C-0.126389 16.451 -0.126389 17.365 0.401111 18.1735L8.03228 29.633Z",
    fill: "url(#paint1_linear_80_4441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.03228 29.633C4.23428 23.9384 3.95295 21.0208 6.55528 16.908L11.338 9.42065H5.71128C4.86728 9.42065 4.09361 9.77217 3.74195 10.3698L0.365945 15.6425C-0.126389 16.451 -0.126389 17.365 0.401111 18.1735L8.03228 29.633Z",
    fill: "url(#paint2_linear_80_4441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.42,
    d: "M0.401111 18.1735L2.54628 21.4074C2.40561 19.5444 2.96828 17.8571 4.23428 15.8886L8.34878 9.42065H5.71128C4.86728 9.42065 4.09361 9.77217 3.74195 10.3698L0.365945 15.6425C-0.126389 16.451 -0.126389 17.365 0.401111 18.1735Z",
    fill: "url(#paint3_linear_80_4441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.5531 0H8.91113L18.4413 14.3068L13.6586 21.7942H19.2853C20.1293 21.7942 20.903 21.4426 21.2546 20.8451L24.6306 15.5723C25.123 14.7638 25.123 13.8498 24.5955 13.0413L16.9643 1.61699C16.2961 0.597582 14.995 0 13.5531 0Z",
    fill: "url(#paint4_linear_80_4441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M13.5531 0H8.91113L18.4413 14.3068L13.6586 21.7942H19.2853C20.1293 21.7942 20.903 21.4426 21.2546 20.8451L24.6306 15.5723C25.123 14.7638 25.123 13.8498 24.5955 13.0413L16.9643 1.61699C16.2961 0.597582 14.995 0 13.5531 0Z",
    fill: "url(#paint5_linear_80_4441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M16.9648 1.61694C20.7629 7.31154 21.0794 10.2291 18.4418 14.3419L13.6592 21.7941H19.2859C20.1299 21.7941 20.9035 21.4426 21.2552 20.845L24.6312 15.5722C25.1235 14.7637 25.1235 13.8498 24.596 13.0413L16.9648 1.61694Z",
    fill: "url(#paint6_linear_80_4441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M16.9648 1.61694C20.7629 7.31154 21.0794 10.2291 18.4418 14.3419L13.6592 21.7941H19.2859C20.1299 21.7941 20.9035 21.4426 21.2552 20.845L24.6312 15.5722C25.1235 14.7637 25.1235 13.8498 24.596 13.0413L16.9648 1.61694Z",
    fill: "url(#paint7_linear_80_4441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    opacity: 0.42,
    d: "M24.5951 13.0765L22.45 9.84253C22.5906 11.7056 22.028 13.3929 20.762 15.3614L16.6475 21.8293H19.3201C20.1641 21.8293 20.9378 21.4778 21.2895 20.8802L24.6655 15.6074C25.1226 14.7989 25.1226 13.8498 24.5951 13.0765Z",
    fill: "url(#paint8_linear_80_4441)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_80_4441",
    x1: 16.103,
    y1: 20.3353,
    x2: -0.0173719,
    y2: 20.3353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A0BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A0056"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_80_4441",
    x1: 5.66908,
    y1: 9.42065,
    x2: 5.66908,
    y2: 29.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A553FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE38FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_80_4441",
    x1: 6.47791,
    y1: 18.4898,
    x2: -3.25544,
    y2: 15.3343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF53FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#AE4DFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#AE45FF",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#AE3FFF",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#AE3BFF",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#AE38FF",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE38FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_80_4441",
    x1: -1.58932,
    y1: 12.5421,
    x2: 11.0164,
    y2: 17.6886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A0BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#2A0056",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_80_4441",
    x1: 8.91113,
    y1: 10.8971,
    x2: 25.021,
    y2: 10.8971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A0BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A0056"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_80_4441",
    x1: 7.63458,
    y1: 6.92843,
    x2: 19.7292,
    y2: 14.1742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A0BFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A0056"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_80_4441",
    x1: 19.328,
    y1: 21.7941,
    x2: 19.328,
    y2: 1.58882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A553FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE38FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_80_4441",
    x1: 18.5227,
    y1: 12.746,
    x2: 28.2561,
    y2: 15.9015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF53FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#AE4DFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#AE45FF",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#AE3FFF",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#AE3BFF",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#AE38FF",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE38FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_80_4441",
    x1: 26.5856,
    y1: 18.7078,
    x2: 13.9798,
    y2: 13.5579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A0BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#2A0056",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80_4441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 31.25,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGla);
export default __webpack_public_path__ + "static/media/gla.c81203b5f8d3b169d7ab60fb6aa9301b.svg";
export { ForwardRef as ReactComponent };